import { breakpoints, colors, effects, icon, shapes, sizes, spacing, typography } from '../tokens'
import { dimensions } from '../tokens/ion/'

export const theme = {
  border: dimensions.border,
  breakpoints,
  colors,
  effects,
  icon,
  name: 'hav-theme',
  radius: dimensions.radius,
  shapes,
  sizes,
  spacing,
  typography,
} as const

export type Theme = typeof theme
